<template>
  <!-- 群蜂 banner广告组件 -->
  <div class="adBox qunfeng-ad" :id="containerId"></div>
</template>
<script>
let adCounter = 0

export default {
  name: 'ad_qunfeng',
  props: {
    positionId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      containerId: 'qunfeng-ad-' + (++adCounter)
    }
  },
  methods: {
    loadAd () {
      try {
        // 获取车场 sid
        const sid = this.$store.state.sid.sid || ''
        console.log('[QunfengAd] 开始加载广告, positionId:', this.positionId, 'projeckNo:', sid, 'el:', this.containerId)

        // 检查群蜂SDK是否已加载
        if (typeof window.qfAd === 'undefined') {
          console.error('[QunfengAd] SDK未加载，请确保已引入 ad.min.js')
          return
        }

        // 初始化群蜂广告
        const self = this
        // eslint-disable-next-line no-new, new-cap
        new window.qfAd({
          containerId: self.containerId,
          positionId: self.positionId,
          projeckNo: sid,
          adCallback: self.adCallback
        })

        console.log('[QunfengAd] 广告初始化完成')
      } catch (err) {
        console.error('[QunfengAd] 加载异常', err)
      }
    },
    adCallback (obj) {
      // 广告回调
      console.log('[QunfengAd] 广告回调:', obj)
      if (obj && obj.code === 1) {
        if (obj.type === 1) {
          console.log('[QunfengAd] 广告展示成功')
        } else if (obj.type === 2) {
          console.log('[QunfengAd] 广告被点击')
        }
      } else {
        console.warn('[QunfengAd] 广告加载失败:', obj ? obj.msg : '未知错误')
      }
    }
  },
  mounted () {
    if (this.positionId) {
      // 等待DOM渲染完成后加载广告
      this.$nextTick(() => {
        this.loadAd()
      })
    } else {
      console.warn('[QunfengAd] positionId为空，跳过加载')
    }
  }
}
</script>

<style scoped>
</style>